<template>
  <div>
    <fullscreen ref="fullscreen" @change="fullscreenChange" background="black" class="EdicaoVideo">
      <!-- <issue-cover :title="issue.title.name" :cover="issue.cover">
			<v-flex md4 lg4 sm4 xs4>
				<v-btn flat color="white" @click="closeReading" class="pa-0 ma-0"><v-icon large>close</v-icon>Fechar<br>leitura</v-btn>
			</v-flex>
			<v-flex md4 lg4 sm4 xs4>
				<v-btn flat color="white" :disabled="sendingForm" :loading="sendingForm" @click="startReading" class="pa-0 ma-0"><v-icon large>burst_mode</v-icon>{{ $t('text.Read') }}</v-btn>
			</v-flex>
			<v-flex md4 lg4 sm4 xs4>
				<v-btn flat color="white" v-bind:class="{ 'primary--text': mediaGallery.fullscreen}" @click="mediaGalleryFullscreen" class="pa-0 ma-0"><v-icon large>fullscreen</v-icon>Tela<br>cheia</v-btn>
			</v-flex>
      </issue-cover>-->

      <focus-gallery
        :class="'mediaGallery-' + issue.type"
        :pages="pages.length"
        :show="mediaGallery.show"
        :image="actualPage.fullFilePath"
        :data="actual"
        :fullscreen="mediaGallery.fullscreen"
        v-on:close="mediaGalleryClose"
        v-on:fullscreen="mediaGalleryFullscreen"
        v-on:prevPage="prevPage"
        v-on:nextPage="nextPage"
      ></focus-gallery>

      <div class="issue-thumbs-container">
        <transition name="slide-in-left">
          <issue-thumbs v-if="showThumbs" :pages="pages" :selectedPage="actualPage"></issue-thumbs>
        </transition>
      </div>
    </fullscreen>

    <link
      rel="next"
      :href="
				`/${$route.params.lang}/issue/video/${
					$route.params.issueId
				}/page/${$route.params.pageNumber + 1}`
			"
    />
    <link
      rel="prerender"
      :href="
				`/${$route.params.lang}/issue/video/${
					$route.params.issueId
				}/page/${$route.params.pageNumber + 1}`
			"
    />
    <link
      v-for="page in pages"
      :key="page.id"
      :href="prefetchImageURL(page.fullFilePath)"
      rel="prefetch"
      as="image"
    />
  </div>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import MediaGallery from '@/components/videoGallery';
import IssueCover from '@/components/issueCover';
import issueThumbs from '@/components/issueThumbs';
//import DialogDefault from '@/components/dialog/Default';

export default {
  name: 'EdicaoVideo',
  components: {
    //'dialog-default': DialogDefault,
    'issue-cover': IssueCover,
    'focus-gallery': MediaGallery,
    'issue-thumbs': issueThumbs
  },
  metaInfo() {
    return {
      title: this.issue.title.name
        ? 'Super Comics - ' +
          this.issue.title.name +
          ' - ' +
          (this.$route.params.pageNumber + 1) +
          '/' +
          this.pages.length
        : 'Super Comics'
    };
  },
  data() {
    return {
      showThumbs: false,
      mediaGallery: {
        show: false,
        fullscreen: false
      },
      issue: {
        title: {
          name: '',
          publisher: {
            name: ''
          }
        }
      },
      pages: [],
      actualPage: {}
    };
  },
  watch: {
    $route() {
      //to, from

      if (this.pages.length > 0) {
        if (this.pages[this.$route.params.pageNumber] !== undefined) {
          this.actualPage = this.pages[this.$route.params.pageNumber];
        } else {
          bus.$emit('loading', false);
          if (this.mediaGallery.show) {
            this.mediaGalleryClose();
          }
        }
      }
    }
  },
  created() {
    bus.$on('show-thumbs', show => {
      this.showThumbs = show;
    });
    // eslint-disable-next-line no-unused-vars
    bus.$on('go-to-page', page => {
      //bus.$emit('loading', false)
    });
  },
  mounted() {
    this.sendingForm = true;
    this.getEdicao();
    this.initGallery();
  },
  computed: {
    actual() {
      return this.actualPage;
    }
  },
  methods: {
    prefetchImageURL(url) {
      if (url == undefined || url === null) {
        return null;
      }
      const stripped = url.substring(0, url.indexOf('?') - 1 + '?'.length);
      return stripped;
    },
    initGallery() {
      if (
        this.$route.params.pageNumber !== undefined &&
        this.mediaGallery.show === false
      ) {
        this.mediaGallery.show = true;
      }
      this.getEdicaoPages();
    },
    startReading() {
      this.mediaGallery.show = true;

      if (this.$route.params.pageNumber == undefined) {
        this.$router.push({
          name: 'EdicaoVideo',
          params: {
            issueId: this.$route.params.issueId,
            pageNumber: 0
          }
        });
      }
    },
    closeReading() {
      this.$router.push({
        name: 'Edicao',
        params: { issueId: this.$route.params.issueId }
      });
    },
    prevPage() {
      if (this.$route.params.pageNumber > 0) {
        this.$router.push({
          name: 'EdicaoVideo',
          params: {
            issueId: this.$route.params.issueId,
            pageNumber: parseInt(this.$route.params.pageNumber) - 1
          }
        });
      } else {
        this.mediaGallery.show = false;
        //this.$router.push({ name: 'EdicaoVideo', params: { issueId: this.$route.params.issueId }})
        this.mediaGalleryClose();
      }
    },
    nextPage() {
      if (this.$route.params.pageNumber < this.pages.length - 1) {
        this.$router.push({
          name: 'EdicaoVideo',
          params: {
            issueId: this.$route.params.issueId,
            pageNumber: parseInt(this.$route.params.pageNumber) + 1
          }
        });
      } else {
        this.mediaGallery.show = false;
        //this.$router.push({ name: 'EdicaoVideo', params: { issueId: this.$route.params.issueId }})
        this.mediaGalleryClose();
      }
    },
    mediaGalleryClose() {
      // this.mediaGallery.show = false
      // bus.$emit('loading', false)
      this.$router.push({
        name: 'Edicao',
        params: { issueId: this.$route.params.issueId }
      });
    },
    mediaGalleryFullscreen() {
      this.$refs['fullscreen'].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.mediaGallery.fullscreen = fullscreen;
    },
    getEdicao() {
      axios
        .get(`/api/issues/${this.$route.params.issueId}`, {})
        .then(response => {
          this.issue = response.data;
          bus.$emit('loading', false);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          // console.error(e)
          this.error = true;
          bus.$emit('loading', false);
        });
    },
    getEdicaoPages() {
      axios
        .get(`/api/issues/${this.$route.params.issueId}/videos?size=1000`, {})
        .then(response => {
          this.pages = response.data.videos;

          if (this.$route.params.pageNumber !== undefined) {
            if (this.pages[this.$route.params.pageNumber] !== undefined) {
              this.actualPage = this.pages[this.$route.params.pageNumber];
            } else {
              this.actualPage = this.pages[0];
            }
          } else {
            this.actualPage = this.pages[0];
          }
          this.loaded = true;
          bus.$emit('loading', false);
          // console.warn(this.pages)
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          // console.error(e)
          this.error = true;
          bus.$emit('loading', false);
        });
    }
  }
};
</script>
<style lang="scss">
.EdicaoVideo {
}
</style>
